export const CREATE_POLICY_OBJECT = 'CREATE_POLICY_OBJECT';

export const GET_THINGS_SUCCESS = 'GET_THINGS_SUCCESS';

export const GENERATE_TOKEN_FAILURE = 'GENERATE_TOKEN_FAILURE';
export const GENERATE_TOKEN_REQUESTED = 'GENERATE_TOKEN_REQUESTED';
export const GENERATE_TOKEN_SUCCESS = 'GENERATE_TOKEN_SUCCESS';

export const THING_CONF_FAILURE = 'THING_CONF_FAILURE';
export const THING_CONF_REQUESTED = 'THING_CONF_REQUESTED';
export const THING_CONF_SUCCESS = 'THING_CONF_SUCCESS';

export const REGEN_PSK_FAILURE = 'REGEN_PSK_FAILURE';
export const REGEN_PSK_REQUESTED = 'REGEN_PSK_REQUESTED';
export const REGEN_PSK_SUCCESS = 'REGEN_PSK_SUCCESS';

export const UPDATE_THING_TOKEN = 'UPDATE_THING_TOKEN';
export const GET_LDAP_TOKEN = 'GET_LDAP_TOKEN';
export const GET_LDAP_TOKEN_SUCCESS = 'GET_LDAP_TOKEN_SUCCESS';
export const GET_LDAP_TOKEN_FAILURE = 'GET_LDAP_TOKEN_FAILURE';

export const GENERATE_IMAGE_STARTED = 'GENERATE_IMAGE_STARTED';
export const GENERATE_IMAGE_SUCCESS = 'GENERATE_IMAGE_SUCCESS';
export const GENERATE_IMAGE_FAILURE = 'GENERATE_IMAGE_FAILURE';

export const GET_BASIC_OBJECTS_REQUESTED = 'GET_BASIC_OBJECTS_REQUESTED';
export const GET_BASIC_OBJECTS_SUCCESS = 'GET_BASIC_OBJECTS_SUCCESS';
export const GET_BASIC_OBJECTS_FAILURE = 'GET_BASIC_OBJECTS_FAILURE';

export const SET_INITIAL_OBJECT_LOADED = 'SET_INITIAL_OBJECT_LOADED';

export const SET_THINGS = 'set_things';
export const CREATE_THING = 'create_thing';
export const UPDATE_THING = 'update_thing';
export const DELETE_THING = 'delete_thing';

export const SET_ADDRESSES = 'set_addresses';
export const CREATE_ADDRESS = 'create_address';
export const UPDATE_ADDRESS = 'update_address';
export const DELETE_ADDRESS = 'delete_address';

export const SET_GATEWAYS = 'set_gateways';
export const CREATE_GATEWAY = 'create_gateway';
export const UPDATE_GATEWAY = 'update_gateway';
export const DELETE_GATEWAY = 'delete_gateway';
